import { useQuery } from '@tanstack/react-query';
import { requestHandler } from 'lib/api';
import { Dispatch } from 'redux';

type CmfResponse = {
  value: number;
  date: string;
  currency: string;
};

export const getUfValue = (dispatch: Dispatch) =>
  useQuery({
    queryKey: ['cmf', 'uf'],
    queryFn: async (): Promise<CmfResponse | undefined> => {
      const response = await requestHandler({
        method: 'get',
        url: 'internal/cmf/uf',
        dispatch,
      });
      if (response) return response.data;
    },
    staleTime: 1000 * 60 * 60 * 6,
    gcTime: 1000 * 60 * 60 * 6,
    retry: 3,
  });

export const getDollarValue = (dispatch: Dispatch) =>
  useQuery({
    queryKey: ['cmf', 'dollar'],
    queryFn: async (): Promise<CmfResponse | undefined> => {
      const response = await requestHandler({
        method: 'get',
        url: 'internal/cmf/dollar',
        dispatch,
      });
      if (response) return response.data;
    },
    staleTime: 1000 * 60 * 60 * 6,
    gcTime: 1000 * 60 * 60 * 6,
    retry: 3,
  });
